<template>
  <v-card elevation="0" rounded="0">
    <v-toolbar dark flat color="brandCyan" rounded="0" width="100%">
      <div>
        <v-toolbar-title>Add a form</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="close">
          <span class="mt-1">Close</span>
          <v-icon class="ml-2">mdi-close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-row no-gutters justify="center" full-width no-wrap class="mb-2">
      <v-col cols="10" class="d-flex flex-column text-left mx-0 my-0">
        <div class="mt-10 d-flex justify-space-between align-center">
          <p class="mb-0 mediumGrey--text">Available Forms</p>
          <v-btn icon color="primary" @click="showHideSearch"><v-icon>mdi-magnify</v-icon></v-btn>
        </div>
        <v-text-field
          v-if="dialog.search"
          ref="search"
          outlined
          placeholder="Search"
          prepend-icon="mdi-magnify"
          single-line
          dense
          hide-details
          v-model="data.search"
          class="mb-5 mt-3"
        ></v-text-field>
      </v-col>
    </v-row>
    <div class="mt-2 mx-12 text-left pb-4">
      <div class="d-flex justify-center" v-if="loadingForms || loading.forms">
        <v-progress-circular indeterminate color="primary" class="mx-auto"></v-progress-circular>
      </div>

      <div v-for="form in visibleForms" :key="form.id">
        <v-hover v-slot="{ hover }">
          <div class="mx-0 px-0 py-1 cursor-pointer" @click="addToProgram(form)">
            <!-- <v-divider /> -->
            <div class="d-flex align-center">
              <v-icon
                class="form-icons"
                :class="hover ? 'primary-background' : `${form.iconColor}-background`"
                color="white"
                >{{ hover ? "mdi-plus" : form.icon }}</v-icon
              >

              <div class="ml-2 px-3 form-box d-flex justify-space-between align-center">
                <span class="form-label">{{ form.displayName }}</span>
              </div>
            </div>

            <!-- <template v-slot:actions>
            <v-icon small>$expand</v-icon>
          </template> -->
          </div>
        </v-hover>
      </div>
    </div>
  </v-card>
</template>

<script>
import FormService from "@/services/FormService";

import { mapState } from "vuex";

export default {
  name: "ProgramFormWidget",
  components: {},
  props: {
    clientId: Number,
    forms: Array,
    loadingForms: Boolean,
    activeProgram: Boolean,
  },
  data() {
    return {
      data: {
        forms: [],
        search: null,
      },
      dialog: {
        value: false,
        search: false,
      },
      loading: {
        forms: false,
      },
      activeTab: 0,

      successForms: [],
    };
  },

  created() {
    // We pass in props and fetch metrics if not passed in
    if (!this.forms) this.getForms();
    if (this.forms) {
      this.data.forms = this.forms;
    }
  },
  mounted() {},
  methods: {
    async getForms() {
      this.loading.forms = true;
      const response = await FormService.getFormsV2(undefined, this.clientId);
      console.log("Forms: ", response);
      this.data.forms = response.result.rows.map((f) => {
        f.id = f.formId.toString();
        f.context = "Forms";
        f.contextResourceId = f.formId.toString();
        f.contextColumn = "formId";
        f.label = f.name;
        f.icon = "mdi-form-dropdown";
        f.iconColor = "brand";
        f.displayGrabber = true;
        f.displayName = f.name;
        return f;
      });
    },
    // getMetrics(metric = null) {
    //   // console.log("get metrics");
    //   console.log(metric);
    //   // console.log("updating", updating);
    //   this.loading.metrics = true;
    //   ProgramService.getMetrics()
    //     .then(response => {
    //       console.log("Metrics: ", response);
    //       var metrics = response
    //         .filter(
    //           metric =>
    //             metric.status !== "Deleted" &&
    //             (metric.clientId == 0 || metric.clientId == this.clientId)
    //         )
    //         .map(x => {
    //           var obj = x;
    //           obj.id = x.metricId.toString();
    //           obj.displayName = x.metricName
    //             ? x.metricName
    //             : "Untitled progress metric";
    //           obj.context = "MetricDefinitions";
    //           obj.contextResourceId = x.metricId.toString();
    //           obj.contextColumn = "metricValue";
    //           obj.label = x.metricName;
    //           obj.dataType = x.dataType;
    //           obj.showNumberOptions =
    //             x.calculateProgress && x.dataType !== "BOOLEAN";
    //           obj.icon =
    //             x.dataType == "BOOLEAN"
    //               ? "mdi-checkbox-marked-outline"
    //               : "mdi-finance";
    //           obj.iconColor = "brand-cyan";
    //           obj.displayGrabber = true;
    //           return obj;
    //         });
    //       this.data.metrics = metrics;
    //       // if (refresh) {
    //       //   this.metrics = metrics;
    //       // }
    //       // Now we emit to update if the metrics were passed in from parents
    //       this.$emit("update-metrics-array", metrics);

    //       this.loading.forms = false;
    //     })
    //     .catch(error => {
    //       console.log("Error getting metrics ", error);
    //       this.loading.forms = false;
    //     });
    // },
    close() {
      this.$emit("close");
    },
    addToProgram(form) {
      console.log("Adding form to program ", form);
      this.$emit("add-to-program", form);

      this.successForms.push(form.formId);

      setTimeout(() => {
        // After 3 seconds we remove the module so the success state goes away
        this.successForms = this.successForms.filter((x) => x != form.formId);
      }, 3000);
    },
    showHideSearch() {
      this.dialog.search = !this.dialog.search;

      this.$nextTick(() => {
        if (this.$refs.search) this.$refs.search.focus();
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "clients"]),
    visibleForms() {
      if (!this.data.search) return this.data.forms;
      return this.data.forms.filter(
        (x) => x.displayName && x.displayName.toLowerCase().includes(this.data.search.toLowerCase())
      );
    },
  },
};
</script>

<style scoped>
/* Used for the table */
.form-icons {
  border-radius: 5px;
  width: 35px;
  min-width: 35px;
  height: 35px;
}

/* Class for the boxes around each item */
.form-box {
  width: 100%;
  overflow-x: hidden;
  overflow-y: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border: 1px solid lightgray;
  border-radius: 5px;
  height: 35px;
}

/* Used to cap the text for the display names for elements if they're too long */
.form-label {
  width: calc(100%);
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-top: 7px;
}
</style>
